import styled from 'styled-components';

/**
 * The Translation Review pane header's dropdown picker (Language Selector
 * trigger pattern): a ghost trigger inside the header's `--text-xs` chrome, and
 * a portaled rounded-row menu. Shared by the reference-language picker on the
 * original pane and the transcript view picker on the translation pane
 * (PLAT-11649), so the two read as one control family.
 */

// Ghost trigger inside the pane header. The negative left margin keeps the
// label flush with the pane's own padding when the trigger is the first item.
export const PickerTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: -2px 0 -2px -8px;
  padding: 2px 8px;
  border: none;
  border-radius: var(--radius-button, 6px);
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;

  &:hover {
    background: var(--surface-elevated);
    color: var(--foreground);
  }
`;

export const PickerMenu = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 220px;
  max-width: 90vw;
  padding: var(--spacing-xs, 4px);
  background: var(--background);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--elevation-toast);
  overflow-y: auto;
`;

// Row per the Language Selector standard: name left, meta right-aligned muted.
// 6px row radius per the canonical ItemDropdownSelect menu rows (rounded-row
// menu, no dividers). Deliberate size deviation from the --text-sm menu
// standard: that standard assumes a --text-sm trigger, but this menu opens from
// the pane header's --text-xs chrome — rows match the trigger scale (12px) so
// the menu doesn't read oversized, with the meta one step below (11px).
export const PickerRow = styled.button<{ $selected: boolean }>`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 16px;
  min-height: 32px;
  padding: 0 10px;
  border: none;
  border-radius: 6px;
  background: transparent;
  text-align: left;
  font-size: var(--text-xs);
  white-space: nowrap;
  color: ${props =>
    props.$selected ? 'var(--accent)' : 'var(--text-secondary)'};
  cursor: pointer;

  &:hover {
    background: var(--surface-elevated);
    color: ${props =>
      props.$selected ? 'var(--accent)' : 'var(--foreground)'};
  }
`;

export const PickerRowMeta = styled.span`
  justify-self: end;
  font-size: 11px;
  color: var(--text-muted);
`;
